import { configureStore } from '@reduxjs/toolkit';
import {
  appDataReducer,
  customizedBlockPageReducer,
  extensionInfoReducer,
  groupsReducer,
  passwordProtectionReducer,
  userReducer,
  checkoutModalReducer,
  flagsConfigReducer,
  webHistoryReducer,
  omniSetupReducer,
  popupMessageReducer,
  onboardingReducer,
  reconsentReducer,
  redirectReducer,
  whitelistReducer,
  unsavedChangesReducer,
  authDisclaimerReducer,
} from './reducers';
import { createCrossTabSyncMiddleware } from './crossTabSyncMiddleware';
import { SLICE_NAMES } from './constants';

const { middleware: crossTabSyncMiddleware } = createCrossTabSyncMiddleware();

const store = configureStore({
  reducer: {
    [SLICE_NAMES.APP_DATA]: appDataReducer,
    [SLICE_NAMES.USER]: userReducer,
    [SLICE_NAMES.EXTENSION_INFO]: extensionInfoReducer,
    [SLICE_NAMES.GROUPS]: groupsReducer,
    [SLICE_NAMES.PASSWORD_PROTECTION]: passwordProtectionReducer,
    [SLICE_NAMES.CUSTOMIZED_BLOCK_PAGE]: customizedBlockPageReducer,
    [SLICE_NAMES.CHECKOUT_MODAL]: checkoutModalReducer,
    [SLICE_NAMES.FLAGS_CONFIG]: flagsConfigReducer,
    [SLICE_NAMES.WEB_HISTORY]: webHistoryReducer,
    [SLICE_NAMES.OMNI_SETUP]: omniSetupReducer,
    [SLICE_NAMES.POPUP_MESSAGE]: popupMessageReducer,
    [SLICE_NAMES.ONBOARDING]: onboardingReducer,
    [SLICE_NAMES.REDIRECT]: redirectReducer,
    [SLICE_NAMES.WHITELIST]: whitelistReducer,
    [SLICE_NAMES.RECONSENT]: reconsentReducer,
    [SLICE_NAMES.UNSAVED_CHANGES]: unsavedChangesReducer,
    [SLICE_NAMES.AUTH_DISCLAIMER]: authDisclaimerReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(crossTabSyncMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
